import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref } from "vue"
import _imports_0 from '../assets/warning-notebook-girl.svg'


const _hoisted_1 = {
  id: "modal-try-again",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-body py-3"
}
const _hoisted_5 = { class: "fs-6 text-start mt-4" }
const _hoisted_6 = {
  key: 1,
  class: "modal-body py-3"
}
const _hoisted_7 = { class: "contact-wrapper" }
const _hoisted_8 = { class: "contact py-3 gap-2" }
const _hoisted_9 = { class: "contact-item" }
const _hoisted_10 = {
  key: 2,
  class: "modal-footer py-3"
}

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalTryAgain',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const arStore = useAR()
  const message = ref<string>('')

  const action = ref<() => any>(() => null)

  onMounted(() => {
    modal.value = new Modal('#modal-try-again', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function setMessage(messageParam: string): void {
    message.value = messageParam
  }

  function setAction(actionParam: () => any) {
    action.value = actionParam
  }

  function callAction() {
    action.value()
    hide()
  }

  __expose({ show, hide, setAction, setMessage })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header pb-3" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Atenção!", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: hide
          })
        ]),
        (message.value.trim().length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                alt: "sucesso",
                src: _imports_0
              }, null, -1)),
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("strong", null, _toDisplayString(message.value), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                alt: "sucesso",
                src: _imports_0
              }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
                _createTextVNode(" Ops! "),
                _createElementVNode("strong", null, "Parece que ocorreu um problema.")
              ], -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
                _createTextVNode(" Por favor, "),
                _createElementVNode("strong", null, "aguarde"),
                _createTextVNode(" um momento e "),
                _createElementVNode("strong", null, "tente novamente.")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "contact-item" }, [
                    _createElementVNode("span", { class: "color--primary fw-600" }, " Ficou alguma dúvida? ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(IconComponent, {
                      class: "icon mx-1",
                      name: "phone"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_unref(arStore).$state.arData.foneAR), 1)
                  ])
                ])
              ])
            ])),
        (message.value.trim().length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: callAction
              }, " Tentar novamente ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})